module.exports = __webpack_public_path__ + "img/search-null-1.cb56e27b.png";